<template>
	<div v-loading="loading">
		<div class="proj-list" v-for="(item, index) in value" :key="index">
			<div class="content-value">
				<div class="table" style="width: 145px; text-align: left;">选择需要发布的网站{{index? index+1: ''}}</div>
				<div class="content-value-main" style="width: calc(100% - 210px);">
					<el-select class="height32" :disabled="detailId !== 'add'" style="width: 100%" v-model="item.projId" placeholder="请选择">
						<el-option v-for="proj in zsList" :key="proj.value" :value="proj.projId" :label="proj.websiteName || proj.projectDomain" :disabled="!!value.find(item => item.projId === proj.projId)"></el-option>
					</el-select>
				</div>
			</div>
			<div class="content-value" style="margin-top: 5px;">
				<div class="table" style="width: 145px; text-align: left;">选择发布网站分类{{index? index+1: ''}}</div>
				<div class="content-value-main" style="width: calc(100% - 210px);">
					<el-cascader class="height32" :ref="'cascader'+index" style="width: 100%; line-height: 32px;" :props="{ checkStrictly: true }" :show-all-levels="false" :disabled="detailId !== 'add'" v-model="pageList[index]" :options="typeList(item.projId)" @change="pageFn(index, 'cascader'+index)"></el-cascader>
				</div>
			</div>
			<!-- <img v-if="index" @click="delFn(index)" src="../../assets/txsvg/icon-delete.svg" title="删除该站点" /> -->
            <i class="el-icon-delete" v-if="index" @click="delFn(index)" title="删除该站点"></i>
		</div>
		<div class="content-value" style="margin-top: 15px;" v-if="zsList.length > value.length">
			<div class="table" style="width: 145px; text-align: left;"> </div>
			<div class="content-value-main add-btn" @click="value.push({projId: '', pageId: ''})">+ 加一个发布站点</div>
		</div>
	</div>
</template>

<script>
    import SiteApi from '@/api/site.api'

	export default {
        data() {
            return {
				// 站神相关
				zsList: [],
				pageList: [],
                loading: false,
			}
        },
		props: {
        	value: Array,
			detailId: String,
			zsList: Array,
		},
        methods: {
			pageFn(index, item) {
				this.$refs[item][0].dropDownVisible = false;
				this.value[index].pageId = this.pageList[index][this.pageList[index].length-1]
			},
			typeList(projId) {
				let arr = this.zsList.find(val => {
					return val.projId === projId
				}) || {detail: []}
				return arr.detail && arr.detail.length? JSON.parse(JSON.stringify(arr.detail).replace(/pageId/g, 'value').replace(/navViceId/g, 'value').replace(/navViceName/g, 'label').replace(/pageName/g, 'label').replace(/child/g, 'children')): []
			},
			delFn(index) {
				this.value.splice(index, 1)
			}
		},
    }
</script>

<style lang="scss">
	.proj-list{
		position: relative;
		i.el-icon-delete{
			position: absolute; top: 25px; right: 0; cursor: pointer; transition: .2s;
			&:hover{
				opacity: .6;
			}
		}
        .content-tit{
				padding: 0 3px 4px; line-height: 30px; font-weight: bold; font-size: 16px; border-bottom: 1px solid #DDDDDD;
				p{
					display: inline-block; margin-left: 28px; font-size: 12px; color: #999; vertical-align: middle; font-weight: 400;
				}
				&.mt60{
					margin-top: 60px;
				}
			}
			.content-value{
				display: flex; margin-top: 30px; justify-content: center;
				.table{
					width: 85px; margin-right: 10px; line-height: 32px; font-size: 14px; text-align: right;
				}
				.content-value-main{
					width: calc(100% - 95px); text-align: center;
					span.point{
						margin-left: 10px; font-size: 12px; color: #999;
					}
				}
			}
	}
	.add-btn{
		width: 115px !important; color: #605CE5; transition: .2s; cursor: pointer; margin: 24px auto 0;
		&:hover{
			opacity: .7;
		}
	}
    .height32 .el-input__inner{ height: 32px !important; line-height: 32px !important; font-size: 12px !important; }
    .height32 .el-select__caret{ height: 32px !important; line-height: 32px !important;}
    .height32 .el-icon-date{ height: 32px !important; line-height: 32px !important;}
    .height32 .el-input__icon{ line-height: 32px !important; height: auto;}
</style>
